import { useEffect, useState } from "react";
import { Outlet } from "react-router";

import { NavListMusic } from "../../arrays/NavLists.js";

// components
import Header from "../navigation/Header.js";
import Footer from "../navigation/Footer.js";

function Music() {
    const [activeTab, setActiveTab] = useState("");
    const currentPage = "Music";
    const typewriterText = "Singer-Songwriter";

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="music">
            <Header
                pageSections={NavListMusic}
                typewriterText={activeTab === "" ? typewriterText : activeTab === "Home" ? typewriterText : activeTab}
                setActiveTab={setActiveTab}
            />

            <main>
                <Outlet />
            </main>

            <Footer
                currentPage={currentPage}
            />
        </div>
    );
};

export default Music;